import React from 'react';
import { useToggle } from 'usehooks-ts';
import { useParams } from 'react-router-dom';

import { Downloadble } from '../../downloadable';
import { DownloadReportAssessmentAsync } from '../../../../services/event-reports';

export const DownloadableCompetencies: React.FC<{
  amount: number;
  fileName: string;
}> = ({ amount, fileName }) => {
  const { eventId, detailId } = useParams();

  const [isLoading, toggleIsLoading] = useToggle(false);

  const onClick = async () => {
    if (!eventId || !detailId) return;

    toggleIsLoading();
    try {
      await DownloadReportAssessmentAsync(eventId, detailId, fileName);
    } catch (err) {
      console.error(err);
    } finally {
      toggleIsLoading();
    }
  };

  return (
    <Downloadble
      onClick={onClick}
      text={'Competencies'}
      icon={'checklist'}
      amount={amount}
      disabled={isLoading}
      bgColor={'#14BF8B'}
      downloadText={isLoading ? 'Downloading' : 'Download XLSX'}
    />
  );
};
